import React, { useState } from 'react';
// import PaginationDiv from '../CommonPages/components/PaginationDiv';
// import AchievementCard from './AchievementCard';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import Publication from './Publication';
import "../../assets/css/tab.css"
import SectionGridLines from '../CommonPages/SectionGridLines';


const AchievementContainer = () => {
    const [tabIndex, setTabIndex] = useState(0);
    const [show2026, setShow2026] = useState(false);
    const [show2026A, setShow2026A] = useState(false);
    const [show2026B, setShow2026B] = useState(false);
    const [show2025, setShow2025] = useState(false);
    const [show2025A, setShow2025A] = useState(false);
    const [show2025B, setShow2025B] = useState(false);
    const [show2025C, setShow2025C] = useState(false);
    const [show2025D, setShow2025D] = useState(false);
    const [show2025E, setShow2025E] = useState(false);
    const [show2024A, setShow2024A] = useState(false);
    const [show2024B, setShow2024B] = useState(false);
    const [show2024C, setShow2024C] = useState(false);
    const [show2023, setShow2023] = useState(false);
    const [show2022, setShow2022] = useState(false);
    const [show2021A, setShow2021A] = useState(false);
    const [show2021B, setShow2021B] = useState(false);
    const [show2020, setShow2020] = useState(false);
    const [show2018, setShow2018] = useState(false);
    const [show2018B, setShow2018B] = useState(false);
    const [show2017, setShow2017] = useState(false);
    const [show2015, setShow2015] = useState(false);
    const [show2014, setShow2014] = useState(false);
    const [show2014B, setShow2014B] = useState(false);
    const [show2012A, setShow2012A] = useState(false);
    const [show2012B, setShow2012B] = useState(false);
    const [show2011A, setShow2011A] = useState(false);
    const [show2011B, setShow2011B] = useState(false);
    const [show2011C, setShow2011C] = useState(false);
    const [show2010A, setShow2010A] = useState(false);

    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const [show4, setShow4] = useState(false);
    const [show5, setShow5] = useState(false);


    return (
        <section className="blog">
            <SectionGridLines />
            <div className="container">
                {/* PUBLICATION */}
                <div className="row">
                    <div className="large_font">
                        <h2 className="floating_element text-dark-200 d-flex justify-content-center">PUBLICATION</h2>
                    </div>

                    <Publication img='images/achievements/IDW.webp' subTitle='Nakshatra' link='https://www.instagram.com/p/DMsqfD8MVxz/?igsh=djhreDJ2bDE3c3Zw' date='2025' dateTime='2025-10-20' mainTitle='INDIA DESIGN WORLD' />

                    <Publication img='images/achievements/archiDiary.webp' subTitle='Avenue 36' link='https://thearchitectsdiary.com/material-arrangement-welcomes-one-with-wooden-fluted-panel-shreesh-design-studio-llp/' date='2024' dateTime='2024-10-20' mainTitle='The Architects Diary' />

                    <Publication img='images/achievements/archiDiary.webp' subTitle='Titan 54' link='https://thearchitectsdiary.com/a-vast-canvas-such-as-this-home-blends-various-interior-styles-shreesh-design-studio-llp/' date='2024' dateTime='2024-10-20' mainTitle='The Architects Diary' />

                    <Publication img='images/achievements/archiDiary.webp' subTitle='Intricate Indian Crafted Door in 50 Timeless Pooja Room door design for Indian Homes' link='https://thearchitectsdiary.com/50-timeless-pooja-room-door-design-for-indian-homes/?fbclid=PAZXh0bgNhZW0CMTEAAabWWDKcU2YlKABIHVqrKc3D8G8dic8-_b7U2OEemQNZIlHUTiALBVu1pdM_aem_ZjxHuIzFKwXbZh3otndk4Q' date='2024' dateTime='2024-10-20' mainTitle='The Architects Diary' />

                    <Publication img='images/achievements/archiDiary.webp' subTitle='Tranquil Haven' link='https://thearchitectsdiary.com/a-productive-working-space-that-resonates-with-the-firms-ethics-shreesh-design-studio-llp/' date='2024' dateTime='2024-10-20' mainTitle='The Architects Diary' />

                    <Publication img='images/achievements/archiDiary.webp' subTitle='The Luxe Wave' link='https://thearchitectsdiary.com/the-luxe-house-captures-affection-an-togetherness-shreesh-design-studio-llp/' date='2024' dateTime='2024-10-20' mainTitle='The Architects Diary' />

                    <Publication img='images/achievements/dezeen.webp' subTitle='Modernized Gurukul' link='https://www.dezeen.com/2024/07/15/colour-humanise-buildings-laura-guido-clark-opinion/?fbclid=PAZXh0bgNhZW0CMTEAAaZaq0cvTPNbW_UpFb5rdT_vKaBMWLZF_oHRTRCAf5CfVPEKlgzZGcPIKPo_aem_lEvYJRDpy9ShCIRqktq5vw' date='2024' dateTime='2022-10-20' mainTitle='Dezeen' />

                    <Publication img='images/achievements/aRCHHELLO.webp' subTitle='Elite Chambers' link='https://archello.com/project/elite-chambers?fbclid=PAZXh0bgNhZW0CMTEAAaZZfOmIzMQILn6Cy7LpriBMgymE9l7ddTTjFy9-NkGr-fmJVkFhAbPvK-I_aem_IP4fKYKVQXzPh4_LHv01kA' date='2024' dateTime='2022-10-20' mainTitle='Archello' />

                    <Publication img='images/achievements/BMREPORTER.webp' subTitle='Modernized Gurukul' link='https://www.buildingmaterialreporter.com/influencers/projects/contemporary-gurukul-school-where-learning-meets-laughter' date='2024' dateTime='2022-10-20' mainTitle='BMReporter' />

                    <Publication img='images/achievements/dezeen.webp' subTitle='Tranquil Haven' link='https://www.instagram.com/p/DCWaPCLOazC/' date='2024' dateTime='2022-10-20' mainTitle='Arc Only' />



                    <Publication img='images/achievements/archiDiary.webp' subTitle='Modernized Gurukul' link='https://thearchitectsdiary.com/a-modernized-gurukul-conceptualised-to-design-this-colourful-pre-school-in-gujarat-shreesh-design-studio/' date='2023' dateTime='2023-10-20' mainTitle='The Architects Diary ' />

                    <Publication img='images/achievements/archiDiary.webp' subTitle='Yamuna Palace' link='https://thearchitectsdiary.com/yamuna-palace-is-an-ode-to-the-diversity-of-indian-culture-art-religion-and-heritage-shreesh-design-studio/' date='2023' dateTime='2023-10-20' mainTitle='The Architects Diary ' />

                    <Publication img='images/achievements/archiDiary.webp' subTitle='Headquarters' link='https://thearchitectsdiary.com/a-productive-working-space-that-resonates-with-the-firms-ethics-shreesh-design-studio-llp/' date='2023' dateTime='2022-10-20' mainTitle='The Architects Diary ' />

                    <Publication img='images/achievements/rethinkingfuture.webp' subTitle='Modernized Gurukul' link='https://www.re-thinkingthefuture.com/architectural-news/a9730-indian-preschool-built-as-colourful-as-the-minds-of-its-users-by-shreesh-design-studio/' date='2023' dateTime='2022-10-20' mainTitle='Re-thinking the Future' />

                    <Publication img='images/achievements/gaga.webp' subTitle='Modernized Gurukul' link='https://www.creativegaga.com/architecture/whimsical-colours-and-playful-learning-exploring-a-vibrant-preschool' date='2023' dateTime='2022-10-20' mainTitle='Creative Gaga' />

                    <Publication img='images/achievements/dezeen.webp' subTitle='Modernized Gurukul' link='https://www.dezeen.com/2023/03/17/shreesh-design-studio-colourful-preschool-india-morbi-gujarat/' date='2023' dateTime='2022-10-20' mainTitle='Dezeen' />

                    <Publication img='images/achievements/dezeen.webp' subTitle='Modernized Gurukul' link='https://www.youtube.com/watch?v=BVvJKsgBMS8&t=2s&ab_channel=Dezeen' date='2023' dateTime='2022-10-20' mainTitle='Dezeen' />

                    <Publication img='images/achievements/arqa.webp' subTitle='Modernized Gurukul' link='https://arqa.com/en/architecture/navyug-pre-school.html' date='2023' dateTime='2022-10-20' mainTitle='Arqa' />

                    <Publication img='images/achievements/surfacemag.webp' subTitle='Modernized Gurukul' link='https://surfacemag.com/articles/palihouse-west-hollywood/' date='2023' dateTime='2022-10-20' mainTitle='Surface mag' />

                    <Publication img='images/achievements/homepublication.webp' subTitle='La Pinoz, Virani CHowk' link='https://www.instagram.com/p/ClgJ8vYS3i9/' date='2023' dateTime='2022-10-20' mainTitle='Home Publication' />

                </div>

                {/* ARTICLE */}
                <div className="row" >
                    <div className="large_font">
                        <h2 className="floating_element text-dark-200 d-flex justify-content-center">ARTICLE</h2>
                    </div>
                    <Tabs
                        selectedIndex={tabIndex}
                        onSelect={tabIndex => setTabIndex(tabIndex)}
                    >
                        <TabList className="d-flex flex-wrap justify-content-between ps-0" style={{ borderBottom: '1px solid gray' }}>
                            <Tab className="yeartab">2026</Tab>
                            <Tab className="yeartab">2025</Tab>
                            <Tab className="yeartab">2024</Tab>
                            <Tab className="yeartab">2023</Tab>
                            <Tab className="yeartab">2022</Tab>
                            <Tab className="yeartab">2021</Tab>
                            <Tab className="yeartab">2020</Tab>
                            <Tab className="yeartab">2018</Tab>
                            <Tab className="yeartab">2017</Tab>
                            <Tab className="yeartab">2015</Tab>
                            <Tab className="yeartab">2014</Tab>
                            <Tab className="yeartab">2012</Tab>
                            <Tab className="yeartab">2011</Tab>
                            <Tab className="yeartab">2010</Tab>
                        </TabList>
                        <div style={{ minHeight: '30rem' }}>
                            <TabPanel className="position-relative">
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2026(true)}>
                                            <img src="images/achievements/articles/article-2026-01.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2026</h2>
                                                <h6 className='mt-2'>Hardware Samachar</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2026} size="lg" centered onHide={() => setShow2026(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Hardware Samachar</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/article-2026-01.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2026A(true)}>
                                            <img src="images/achievements/articles/article-2026-02.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2026</h2>
                                                <h6 className='mt-2'>Hardware Samachar</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2026A} size="lg" centered onHide={() => setShow2026A(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Hardware Samachar</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/article-2026-02.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2026B(true)}>
                                            <img src="images/achievements/articles/article-2026-02.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2026</h2>
                                                <h6 className='mt-2'>Hardware Samachar</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2026B} size="lg" centered onHide={() => setShow2026B(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Hardware Samachar</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/article-2026-02.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel className="position-relative">
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2025(true)}>
                                            <img src="images/achievements/articles/article-2025-01.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2025</h2>
                                                <h6 className='mt-2'>Sampati Times</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2025} size="lg" centered onHide={() => setShow2025(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Sampati Times</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/article-2025-01.jpeg" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2025A(true)}>
                                            <img src="images/achievements/articles/article-2025-02.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2025</h2>
                                                <h6 className='mt-2'>Sampati Times</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2025A} size="lg" centered onHide={() => setShow2025A(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Sampati Times</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/article-2025-02.jpeg" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2025B(true)}>
                                            <img src="images/achievements/articles/2025-FOAID-01.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2025</h2>
                                                <h6 className='mt-2'>FOAID</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2025B} size="lg" centered onHide={() => setShow2025B(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>FOAID</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2025-FOAID-01.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2025C(true)}>
                                            <img src="images/achievements/articles/2025-FOAID-02.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2025</h2>
                                                <h6 className='mt-2'>FOAID</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2025C} size="lg" centered onHide={() => setShow2025C(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>FOAID</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2025-FOAID-02.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2025D(true)}>
                                            <img src="images/achievements/articles/2025-FOAID-03.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2025</h2>
                                                <h6 className='mt-2'>FOAID</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2025D} size="lg" centered onHide={() => setShow2025D(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>FOAID</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2025-FOAID-03.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2025E(true)}>
                                            <img src="images/achievements/articles/2025-FOAID-04.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2025</h2>
                                                <h6 className='mt-2'>FOAID</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2025E} size="lg" centered onHide={() => setShow2025E(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>FOAID</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2025-FOAID-04.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel className="position-relative">
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2024A(true)}>
                                            <img src="images/achievements/articles/article-2024.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2024</h2>
                                                <h6 className='mt-2'>Elegance</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2024A} size="lg" centered onHide={() => setShow2024A(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Elegance</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/article-2024.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2024B(true)}>
                                            <img src="images/achievements/articles/article-2024-(2).webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2024</h2>
                                                <h6 className='mt-2'>Elegance</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2024B} size="lg" centered onHide={() => setShow2024B(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Elegance</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/article-2024-(2).webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2024C(true)}>
                                            <img src="images/achievements/articles/article-2024-(3).webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2024</h2>
                                                <h6 className='mt-2'>Elegance</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2024C} size="lg" centered onHide={() => setShow2024C(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Elegance</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/article-2024-(3).webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel className="position-relative">
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2023(true)}>
                                            <img src="images/achievements/articles/2023-c.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2023</h2>
                                                <h6 className='mt-2'>FOAID</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2023} size="lg" centered onHide={() => setShow2023(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>FOAID</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/FOAID.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel className="position-relative">
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2022(true)}>
                                            <img src="images/achievements/articles/2022-2.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2 >2022</h2>
                                                <h6 className='mt-2'>Construction & Architecture Update</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2022} size="lg" centered onHide={() => setShow2022(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Construction & Architecture Update</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2022-1.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2021A(true)}>
                                            <img src="images/achievements/articles/2021-1c.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2 >2021</h2>
                                                <h6 className='mt-2'>Construction & Architecture Update</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2021A} size="lg" centered onHide={() => setShow2021A(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Construction & Architecture Update</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2021-1i.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2021B(true)}>
                                            <img src="images/achievements/articles/2021-2c.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2 >2021</h2>
                                                <h6 className='mt-2'>Inside Architecture Magazine</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2021B} size="lg" centered onHide={() => setShow2021B(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Inside Architecture Magazine</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2021-2i.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2020(true)}>
                                            <img src="images/achievements/articles/2020-c.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2 >2020</h2>
                                                <h6 className='mt-2'>Construction & Architecture Update</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2020} size="lg" centered onHide={() => setShow2020(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Construction & Architecture Update</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2020-i.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2018(true)}>
                                            <img src="images/achievements/articles/2018-ca.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2018</h2>
                                                <h6 className='mt-2'>Construction & Architecture Update</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2018} size="lg" centered onHide={() => setShow2018(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Construction & Architecture Update</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2018-ca.webp" alt="" />
                                                    <img className='mt-2' src="images/achievements/articles/2018-ia.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2018B(true)}>
                                            <img src="images/achievements/articles/2018-cb.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2018</h2>
                                                <h6 className='mt-2'>Construction & Architecture Update</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2018B} size="lg" centered onHide={() => setShow2018B(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Construction & Architecture Update</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2018-ib1.webp" alt="" />
                                                    <img className='mt-2' src="images/achievements/articles/2018-ib2.webp" alt="" />
                                                    <img className='mt-2' src="images/achievements/articles/2018-ib3.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2017(true)}>
                                            <img src="images/achievements/articles/2017-c.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2017</h2>
                                                <h6 className='mt-2'>Construction & Architecture Update</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2017} size="lg" centered onHide={() => setShow2017(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Construction & Architecture Update</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2017-i.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>

                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2015(true)}>
                                            <img src="images/achievements/articles/2015-c.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2015</h2>
                                                <h6 className='mt-2'>Construction & Architecture Update</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2015} size="lg" centered onHide={() => setShow2015(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Construction & Architecture Update</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2015-i1.webp" alt="" />
                                                    <img src="images/achievements/articles/2015-i2.webp" alt="" />
                                                    <img src="images/achievements/articles/2015-i3.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>

                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2014(true)}>
                                            <img src="images/achievements/articles/2014.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2014</h2>
                                                <h6 className='mt-2'>Akila</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2014} size="lg" centered onHide={() => setShow2014(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Akila</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2014.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2014B(true)}>
                                            <img src="images/achievements/articles/2014-c.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2014</h2>
                                                <h6 className='mt-2'>Rajkot Now</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2014B} size="lg" centered onHide={() => setShow2014B(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Rajkot Now</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <center>
                                                        <img src="images/achievements/articles/2014-b.webp" alt="" />
                                                        <img src="images/achievements/articles/2014-b2.webp" alt="" />
                                                    </center>
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>

                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2012A(true)}>
                                            <img src="images/achievements/articles/2012-c.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2012</h2>
                                                <h6 className='mt-2'>Construction & Architecture Update</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2012A} size="lg" centered onHide={() => setShow2012A(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Construction & Architecture Update</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2012-i1A.webp" alt="" />
                                                    <img className='mt-2' src="images/achievements/articles/2012-i2A.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2012B(true)}>
                                            <img src="images/achievements/articles/2012-c2.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2012</h2>
                                                <h6 className='mt-2'>Rajkotwala</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2012B} size="lg" centered onHide={() => setShow2012B(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Rajkotwala</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <center>
                                                        <img src="images/achievements/articles/2012-i1b.webp" alt="" />
                                                        <img src="images/achievements/articles/2012-i2b.webp=" alt="" />
                                                    </center>
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>

                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2011A(true)}>
                                            <img src="images/achievements/articles/2011-a.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2011</h2>
                                                <h6 className='mt-2'>Construction & Architecture Update <br />(Jan-Feb)</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2011A} size="lg" centered onHide={() => setShow2011A(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Construction & Architecture Update (Jan-Feb)</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2011-a.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2011B(true)}>
                                            <img src="images/achievements/articles/2011-b.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2011</h2>
                                                <h6 className='mt-2'>Construction & Architecture Update <br /> (Jul-Aug)</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2011B} size="lg" centered onHide={() => setShow2011B(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Construction & Architecture Update(Jul-Aug)</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2011-b.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2011C(true)}>
                                            <img src="images/achievements/articles/2011-c3.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2011</h2>
                                                <h6 className='mt-2'>Construction & Architecture Update <br /> (Jul-Aug)</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2011C} size="lg" centered onHide={() => setShow2011C(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Construction & Architecture Update(Jul-Aug)</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <center>
                                                        <img src="images/achievements/articles/2011-i1c.webp" alt="" />
                                                        <img className='mt-2' src="images/achievements/articles/2011-i2c.webp" alt="" />
                                                    </center>
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>


                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="mt-2 articals" onClick={() => setShow2010A(true)}>
                                            <img src="images/achievements/articles/2010-c1.webp" alt="" />
                                            <div className='artical-details'>
                                                <h2>2010</h2>
                                                <h6 className='mt-2'>Construction & Architecture Update <br />(Jan-Feb)</h6>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal show={show2010A} size="lg" centered onHide={() => setShow2010A(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Construction & Architecture Update (Jan-Feb)</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <img src="images/achievements/articles/2010-ia1.webp" alt="" />
                                                    <img className='mt-2' src="images/achievements/articles/2010-ia2.webp" alt="" />
                                                </Modal.Body>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>
                        </div>
                    </Tabs>
                </div>

                {/* AWARDS */}
                <div className="row justify-content-center">
                    <div className="large_font">
                        <h2 className="floating_element text-dark-200 d-flex justify-content-center">AWARDS</h2>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-2">
                        <div className="mt-2 articals" onClick={() => setShow4(true)}>
                            <img src="images/achievements/awards/2018-1.webp" alt="" style={{ maxHeight: '31rem', width: '100%' }} />
                            <div className='artical-details'>
                                <h2 >2018</h2>
                                <h6 className='mt-2'>The Luminaries by Divya Bhaskar</h6>
                            </div>
                        </div>
                        <div>
                            <Modal show={show4} size="lg" centered onHide={() => setShow4(false)}>
                                <Modal.Header closeButton>
                                    <Modal.Title>The Luminaries by Divya Bhaskar</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <img src="images/achievements/awards/2018-1.webp" alt="" />
                                </Modal.Body>
                            </Modal>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className='mb-2'>
                            <div className="mt-2 articals" onClick={() => setShow3(true)}>
                                <img src="images/achievements/awards/2016-1.webp" alt="" style={{ maxHeight: '18rem', width: '100%' }} />
                                <div className='artical-details'>
                                    <h2 >2016</h2>
                                    <h6 className='mt-2 text-center'>Times Cyber Media</h6>
                                </div>
                            </div>
                            <div>
                                <Modal show={show3} size="lg" centered onHide={() => setShow3(false)}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Times Cyber Media</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <img src="images/achievements/awards/2016-1.webp" alt="" />
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                        <div className='mb-2 '>
                            <div className="mt-2 articals" onClick={() => setShow2(true)}>
                                <img src="images/achievements/awards/2021-1.webp" alt="" style={{ maxHeight: '18rem', width: '100%' }} />
                                <div className='artical-details'>
                                    <h2 >2021</h2>
                                    <h6 className='mt-2 text-center'>Realicon Conclave & Awards by Divyabhaskar</h6>
                                </div>
                            </div>
                            <div>
                                <Modal show={show2} size="lg" centered onHide={() => setShow2(false)}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Realicon Conclave & Awards by Divyabhaskar</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <img src="images/achievements/awards/2021-1.webp" alt="" />
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className='mb-2 '>
                            <div className="mt-2 articals" onClick={() => setShow1(true)}>
                                <img src="images/achievements/awards/2023-1.webp" alt="" style={{ maxHeight: '18rem', width: '100%' }} />
                                <div className='artical-details'>
                                    <h2 >2023</h2>
                                    <h6 className='mt-2'>Property Expo & Showcase</h6>
                                </div>
                            </div>
                            <div>
                                <Modal show={show1} size="lg" centered onHide={() => setShow1(false)}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Property Expo & Showcase</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <img src="images/achievements/awards/2023-1.webp" alt="" />
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                        <div className='mb-2 '>
                            <div className="mt-2 articals" onClick={() => setShow5(true)}>
                                <img src="images/achievements/awards/2024.webp" alt="" style={{ maxHeight: '18rem', width: '100%' }} />
                                <div className='artical-details'>
                                    <h2 >2024</h2>
                                    <h6 className='mt-2'>ERA Fame</h6>
                                </div>
                            </div>
                            <div>
                                <Modal show={show5} size="lg" centered onHide={() => setShow5(false)}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>ERA Fame</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <img src="images/achievements/awards/2024.webp" alt="" />
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                    </div>




                    {/* <AchievementCard img='images/blog/6.webp' title='Recent trends in designing space interiors 2019' text='Lorem ipsum dolor sit amet consecteur adipiscing elitsed do eiusmod tempor incididunt labo dolore magnaaliqua. Ut eni ad minim veniam dolor sit amet consecteur.....' date='OCTOBER 20, 2022' dateTime='2022-10-20' postCount='06' />  */}
                </div>
                {/* <PaginationDiv /> */}
            </div>
        </section>
    );
};

export default AchievementContainer;